// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FotnM","option":"styles_option__md6iv","active":"styles_active__1-2lX"};